const {gql} = require('graphql-tag');
export default gql`
  mutation removeCallsheet($id: ID!) {
    removeCallsheet(id: $id) {
      id
    }
  }
`;
